/* eslint semi:0 */
import m from 'mithril'
import BaseView from './BaseView'
import { makeSafeFn } from '../../utils/fn'
import { queryString } from '../../utils/window'
import { map as objectMap } from '../../utils/object'

const ELEMENT_CLASS = 'BrightcoveExperience'

export default class BrightcovePlayerView extends BaseView {
  view(ctrl) {
    let { vm } = ctrl
    return this.shouldRender(vm) ? this.renderView(vm) : this.renderNothing()
  }

  shouldRender(vm) {
    return vm.isExternalLoaded
  }

  renderView(vm) {
    return m(
      `object#${vm.elementId}.${ELEMENT_CLASS}`,
      { config: this.postRender.part(vm) },
      this.getElementChildren(vm)
    )
  }

  renderNothing() {
    return null
  }

  getElementChildren(vm) {
    return objectMap(vm.htmlParams, this.elementChild)
  }

  elementChild(paramName, value) {
    return m('param', {
      name: paramName,
      value,
    })
  }

  postRender(vm, element, isInitialized, context) {
    if (isInitialized || queryString.noBcScript) {
      return
    }
    makeSafeFn(function callBcCreateExperiences() {
      window.brightcove.createExperiences(null, vm.elementId)
    }).invoke()
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/BrightcovePlayerView.js